import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { WrapperComponent } from './wrapper/wrapper.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { TenantSwitcherComponent } from './header/tenant-switcher/tenant-switcher.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { MenuitemComponent } from './menuitem/menuitem.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TenantActionService } from '../tenant/services/tenant-action.service';
import { AppConfigPanelComponent } from './config/admin-config.component';
import { AuthService } from '../auth/services/auth.service';

@NgModule({
    declarations: [
        WrapperComponent,
        MenuitemComponent,
        HeaderComponent,
        TenantSwitcherComponent,
        SidebarComponent,
        FooterComponent,
        AppConfigPanelComponent,
    ],
    imports: [CommonModule, RouterModule, RouterOutlet, SharedModule, ReactiveFormsModule],
    exports: [WrapperComponent, HeaderComponent],
    /* Angular no longer allows exporting services from one module 
     and then importing that module to use the services elsewhere. 
     That’s why services are directly added here in the providers array. */
    providers: [
        TenantActionService,
        AuthService,
        // ========================================================================================
        // ------TODO: FCMService provider temporarily disabled under ticket #511.--------
        // ========================================================================================
        // FCMService,
    ],
})
export class LayoutModule {}
